<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" id="my-modal-title">{{ this.title | globalTranslate }}</h1>
    <button type="button" class="btn-close pull-right" [attr.aria-label]="(this.close)" (click)="onCancel()">
      <img src="../../assets/images/⚛️ icons-close-circle-outline.svg" alt="close-icon"/>
    </button>
  </div>
  <div class="modal-body">
    <div class="nh-table-mobile d-lg-none">

      <div class="mobile-table-header">{{ this.type1 | globalTranslate }}</div><hr>
      <div class="mobile-table-data"> {{ this.type1Description | globalTranslate}}</div><br>

      <div class="mobile-table-header">{{ this.type2 | globalTranslate }}</div><hr>
      <div class="mobile-table-data"> {{ this.type2Description | globalTranslate }} </div><br>;
      <div class="mobile-table-header">{{ this.type3 | globalTranslate }}</div><hr>
      <div class="mobile-table-data">{{ this.type3Description | globalTranslate }} </div><br>

      <div class="mobile-table-header">{{ this.type4 | globalTranslate }}</div><hr>
      <div class="mobile-table-data">{{ this.type4Description | globalTranslate }}</div><br>;
      <div class="mobile-table-header">{{ this.type5 | globalTranslate }}</div><hr>
      <div class="mobile-table-data">{{ this.type5Description | globalTranslate }}</div><br>

      <div class="mobile-table-header">{{ this.type6 | globalTranslate }}</div><hr>
      <div class="mobile-table-data">{{ this.type6Description | globalTranslate }}</div><br>

      <div class="mobile-table-header">{{ this.type7 | globalTranslate }}</div><hr>
      <div class="mobile-table-data">{{ this.type7Description | globalTranslate }}</div><br>
    </div>

    <table class="d-none d-lg-block table table-striped modal-table">
      <thead>
        <tr class="header-sty">
          <th scope="col">{{ this.title1 | globalTranslate }}</th>
          <th scope="col">{{ this.description | globalTranslate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td [ngStyle]="isGlobalLang() ? {'overflow-wrap': 'break-word'} : {}">{{ this.type1 | globalTranslate }}</td>
          <td>{{ this.type1Description | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{ this.type2 | globalTranslate }}</td>
          <td>{{ this.type2Description | globalTranslate }}</td>
        </tr>
        <tr>
          <td [ngStyle]="isGlobalLang() ? {'overflow-wrap': 'break-word'} : {}">{{ this.type3 | globalTranslate }}</td>
          <td>{{ this.type3Description | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{ this.type4 | globalTranslate }}</td>
          <td>{{ this.type4Description | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{ this.type5 | globalTranslate }}</td>
          <td>{{ this.type5Description | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{ this.type6 | globalTranslate }}</td>
          <td>{{ this.type6Description | globalTranslate }}</td>
        </tr>
        <tr>
          <td>{{ this.type7 | globalTranslate }}</td>
          <td>{{ this.type7Description | globalTranslate }}</td>
        </tr>
      </tbody>
    </table>

  </div>
</div>
